import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { initializeMetaPixel, prepareMetaPixel } from "./utils/metaPixel";
const HERO_BACKGROUND = "https://cdn.magicpatterns.com/patterns/generated-images/d8d10b79-d465-4647-bd26-634d9e411ccb.jpg";
const preconnectHosts = ["https://cdn.magicpatterns.com", "https://fonts.googleapis.com", "https://fonts.gstatic.com"];
preconnectHosts.forEach(href => {
  const link = document.createElement("link");
  link.rel = "preconnect";
  link.href = href;
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
});
const heroPreload = document.createElement("link");
heroPreload.rel = "preload";
heroPreload.as = "image";
heroPreload.href = HERO_BACKGROUND;
heroPreload.setAttribute("fetchpriority", "high");
document.head.appendChild(heroPreload);

// Queue PageView synchronously; only the external analytics script is deferred.
prepareMetaPixel();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-441" data-mp="1ajvmywnc41l1" />);
}

// Keep analytics from competing with React and the hero during first paint.
type IdleWindow = Window & {
  requestIdleCallback?: (callback: () => void, options?: {
    timeout: number;
  }) => number;
};
const idleWindow = window as IdleWindow;
if (idleWindow.requestIdleCallback) {
  idleWindow.requestIdleCallback(initializeMetaPixel, {
    timeout: 2000
  });
} else {
  window.setTimeout(initializeMetaPixel, 500);
}